import { render } from 'preact';
import { App } from './app.jsx';
import { installBackGuard } from './lib/backGuard.js';
import './styles/index.css';

installBackGuard();

render(<App />, document.getElementById('app'));
